var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomersupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.119,
    height: 26.119,
    viewBox: "0 0 41.119 41.119",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1719.247 -93.248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.42,39.7V33.535A16.279,16.279,0,1,1,34.552,17.276c0,8.481-5.894,17.013-14.683,21.245Zm-.857-15.574H19.99v3.427H16.563Zm3.427-2.57H16.563c0-5.568,5.14-5.14,5.14-8.566a3.427,3.427,0,1,0-6.853,0H11.423a6.853,6.853,0,0,1,13.706,0C25.129,17.276,19.99,17.7,19.99,21.559Z",
    transform: "translate(1720.673 93.961)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1719.247 93.248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H41.119V41.119H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.64,21.99h3.427v3.427H12.64Zm3.427-2.57H12.64c0-5.568,5.14-5.14,5.14-8.566a3.427,3.427,0,0,0-6.853,0H7.5a6.853,6.853,0,0,1,13.706,0C21.206,15.136,16.066,15.565,16.066,19.42Z",
    transform: "translate(5.35 2.853)",
    fill: "#008bff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomersupport);
export default __webpack_public_path__ + "static/media/Customer support.68db099790d5bd83f648c1cb73065380.svg";
export { ForwardRef as ReactComponent };